import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import Modal from 'react-bootstrap/Modal';
import ChatService from '../../services/ChatService';
import Moment from 'react-moment';
import DataTable from '../DataTable';
import useApi from '../../api/useApi';
import useAuth from '../../context/useAuth';
import useQueryParams from '../../context/useQueryParams';
import { NumericFormat } from 'react-number-format';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';

const LotUpdateView = () => {

    const navigate = useNavigate();
    const { id } = useParams();
    const [lotSummary, setLotSummary] = useState({});
    const lotSummaryRef = React.useRef(lotSummary);
    const [lotDetailsData, setLotDetailsData] = useState([]);
    const api = useApi();
    const { auth } = useAuth();
    const { setParameters } = useQueryParams();
    const [role] = useState(auth?.role?.toLowerCase());
    const gridApi = React.useRef(null);
    const [traderwiseReport, setTraderwiseReport] = useState([]);
    const [withdrawReason, setWithdrawReason] = useState([]);
    const [selectedLot, setSelectedLot] = useState({});
    const [withdrawModalVisible, setwithdrawModalVisible] = useState(false);
    const [traderwiseModalVisible, setTraderwiseModalVisible] = useState(false);
    const [lotwiseGridApi, setlotwiseGridApi] = useState(null);
    const [traderwiseGridApi, setTraderwiseGridApi] = useState(null);
    const scrollTop = useRef(0);

    const handleOnConnectionEstablished = useRef(() => {

    }).current;

    const handleOnMessageReceived = useRef((message) => {

        if (message) {
            switch (message.message) {
                case 'START_LOT':
                case 'LOT_SOLD':
                case 'LOT_WITHDRAWN':
                case 'LOT_RERUN':
                    {
                        fetchDataFromApi();
                        break;
                    }
                default:
            }
        }
    }).current;

    const _chatService = ChatService({ onConnectionEstablished: handleOnConnectionEstablished, messageReceived: handleOnMessageReceived });

    const handleInputChange = (e) => {
        setWithdrawReason({
            withdrawReason: e.target.value,
        });
    };


    const handleCellValueChanged = (params) => {
        // Extract the updated data from the grid

        const updatedData = lotDetailsData.map((row) =>
            row.lotId === params.data.lotId ? { ...row, [params.colDef.field]: params.newValue } : row
        );

        // Update the state with the new data
        setLotDetailsData(updatedData);

        // You can also perform additional actions with the updated data
    };

    const totalValueRenderer = (props) => {
        const cellValue = props.valueFormatted ? props.valueFormatted : props.value;

        const buttonClicked = () => {
            alert(`${cellValue} medals won!`);
        };

        return (
            <span>
                <span>{cellValue}</span>
                <br></br>
                <button className="btn btn-sm ripple btn-outline-primary fs-11 mg-t-5" onClick={() => buttonClicked()}>Lot Detail</button>
            </span>
        );
    };

    const linkRenderer = (props) => {

        const planterOrDealer = (props.node.data.planterDealer === '1' ? "P" : (props.node.data.planterDealer === '2' ? "D" : props.node.data.planterDealer));
        const cellValue = props.valueFormatted ? props.valueFormatted : props.value + ' (' + planterOrDealer + ')';

        return (
            <span>
                <span className="custom-link">{cellValue}</span>
            </span>
        );
    };

    const amountRenderer = (props) => {
        const cellValue = props.valueFormatted ? props.valueFormatted : props.value;
        return (
            <span>
                <span><NumericFormat prefix={'₹ '} displayType="text" value={cellValue} allowLeadingZeros thousandSeparator="," decimalScale={2} /> </span>
            </span>
        );
    };

    const statusRenderer = (props) => {
        const cellValue = props.valueFormatted ? props.valueFormatted : props.value;
        return (
            <span className="has-withdraw-btn">
                <span>{cellValue}
                    {/*onClick={() => viewPoolingDetail(auctionId)}*/}
                    {props.node.data.status === 8 ?
                        <div className="after-sold-withdraw-btn">
                            <button className="btn ripple btn-outline-danger mg-l-10 btn-sm" type="button" onClick={() => openWithdrawModal(props.node.data)}>
                                Withdraw
                            </button>
                        </div> : null}
                </span>
            </span>
        );
    };

    const columns = [
        {
            headerName: 'Lot No.', field: 'lotNumber', cellClass: 'text-center', width: 60
        },
        {
            headerName: 'Name of the Grower (Planter / Dealer)',
            field: 'planterName', flex: 1, minWidth: 280, wrapText: true, autoHeight: true,
            cellRenderer: linkRenderer
        },
        { headerName: 'Quantity (Kg)', field: 'quantityKg', cellClass: 'text-center', width: 90 },
        { headerName: 'No. of Bags', field: 'bags', cellClass: 'text-center', width: 70 },
        { headerName: 'Litre Weight (gm)', field: 'litreWeightGms', cellClass: 'text-center', width: 120 },
        {
            headerName: 'Starting Price (₹)', cellClass: 'highlight-light text-center',
            field: 'auctionStartPriceRs', width: 90, editable: (params) => (lotSummary.auctionStatus !== 2 && params.data.status === 0)

        },
        {
            headerName: 'Reserve Price (₹)', cellClass: 'highlight-light2 text-center',
            field: 'reservedPrice', width: 90, editable: (params) => (lotSummary.auctionStatus !== 2 && params.data.status === 0)
        },
        { headerName: 'Status', field: 'statusName', cellClass: 'text-center', width: 160, cellRenderer: statusRenderer },
        { headerName: 'Final Price (₹)', field: 'finalPrice', cellClass: 'text-center', width: 100, cellRenderer: amountRenderer },
        { headerName: 'Buyer Name', field: 'buyerName', width: 300, autoHeight: true },
        { headerName: 'Buyer Mobile Number', field: 'buyerMobileNumber', cellClass: 'text-center', width: 130 },
        { headerName: 'Withdraw Reason', field: 'withdrawReason', cellClass: 'text-center', width: 300 },
        { headerName: 'Withdraw By', field: 'withdrawBy', cellClass: 'text-center', width: 300 },
        //{ headerName: ' ', field: row => <button cellclassName="btn ripple btn-outline-primary text-nowrap btn-sm btn-rounded mg-r-5" onClick={() => viewLotDetails(row.lotId)}> <i cellclassName="fe fe-edit-2"></i> Detail</button> },
    ];

    const gridOptions = {

        defaultColDef: {
            wrapHeaderText: true,
            autoHeaderHeight: true,
            sortable: false,
        },
        rowClass: 'custom-grid-font',
        getRowClass: params => {
            if (params.node.data.status === 8) {
                return 'bg-lot-completed';
            }
            else if (params.node.data.status === 6) {
                return 'bg-lot-withdrawn';
            }
            else if (params.node.data.status >= 1 && params.node.data.status <= 5) {
                return 'bg-lot-inprogress';
            }
            else if (params.node.data.status === 7) {
                return 'bg-lot-skip';
            }
        },
        columnDefs: columns,
    };

    const fetchDataFromApi = async () => {
        try {
            let lotData = await api.getAuctioneerLots(id);
            setLotDetailsData(lotData.lotDetail);
            lotData.lotDetail = null;
            setLotSummary(lotData);
            lotSummaryRef.current = lotData;

        } catch (error) {
            alert('Unable to fetch lot detail data.');
        }
    };

    useEffect(() => {
        fetchDataFromApi();
    }, []);


    const getRowStyle = params => {
        //if (params.node.rowIndex % 2 === 0) {
        return { background: '#fff' };
        //}
    };


    const withdrawLot = async () => {
        const payload = {
            lotId: selectedLot.lotId,
            auctionId: selectedLot.auctionId,
            withdrawReason: withdrawReason.withdrawReason
        }
        await api.saveWithdrawSoldLot(payload)
            .then((response) => {
                if (response.success) {
                    fetchDataFromApi();
                    setwithdrawModalVisible(false);
                    alert("Lot withdrawn successfully");
                }
                else
                    alert(response.message);
            })
            .catch((error) => {
                console.error('Error saving lot price data:', error);
            });
    };


    const openWithdrawModal = (lot) => {
        setSelectedLot(lot)
        setwithdrawModalVisible(true);
    }

    const closeWithdrawModal = () => {
        setwithdrawModalVisible(false);
    }

    const closeTraderwiseModal = () => {
        setTraderwiseModalVisible(false);
    }



    return (
        <div>
            <div className="inner-body">
                <div className="page-header">
                    <div>
                        <h2 className="main-content-title tx-24 mg-b-5">Current Auction Lots</h2>
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item">
                                <a className="custom-link" onClick={() => navigate('/home')}>Home</a></li>
                            <li className="breadcrumb-item active" aria-current="page">Current Auction Lots</li>
                        </ol>
                    </div>

                </div>

                <div className="row row-sm">
                    <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 grid-margin">
                        <div className="card custom-card">
                            <div className="card-body">

                                <div>
                                    <div
                                        style={{ height: 500 }}
                                        className={
                                            "ag-theme-alpine"
                                        }
                                    >

                                        <AgGridReact
                                            className="auctionLotsGrid"
                                            deltaRowDataMode={true}
                                            suppressScrollOnNewData={true}
                                            gridOptions={gridOptions}
                                            rowData={lotDetailsData}
                                            getRowStyle={getRowStyle}
                                            onGridReady={(params) => (gridApi.current = params)}
                                            onCellValueChanged={handleCellValueChanged}
                                        />

                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Modal show={withdrawModalVisible} onHide={closeWithdrawModal}>
                <Modal.Header closeButton>
                    <Modal.Title>Lot Withdraw
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className="pd-t-0">
                    <div
                        style={{ marginTop: '10px' }}
                        className={
                            "ag-theme-alpine"
                        }
                    >
                        <h5 className="text-danger text-center">You are about to WITHDRAW <br></br> a sold Lot No. <strong> {selectedLot.lotNumber}</strong>.  </h5>
                        <div className="text-center"> Are you sure you want to continue?</div>

                        <label className="mt-4" >Please enter a reason to withdraw this lot.</label>

                        <textarea className="form-control" onChange={handleInputChange} value={selectedLot.withdrawReason}>

                        </textarea>
                    </div>
                    <div className="mg-t-6 mt-3">
                        <button className="btn ripple btn-danger pd-x-30 btn-sm mg-r-5" type="button" onClick={() => withdrawLot()}>
                            Submit
                        </button>
                        <button className="btn ripple btn-light  btn-sm pd-x-30" onClick={() => closeWithdrawModal()}>
                            Cancel
                        </button>
                    </div>
                </Modal.Body>
            </Modal>

        </div>
    );
}

export default LotUpdateView;